import ShortsSdkVersion from "../../common/SDKVersion";
import {
  CreateContentMediaIcon,
  CreateContentTextIcon,
} from "../../../assets/icons/CreateContentSidebarIcons";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";

// function SidebarLink({ route, label, imgSrc }: any) {
function SidebarLink({ route, label, imgSrc }: any) {
  const { pathname } = useLocation();

  const isLinkActive = useCallback(
    (path: any) => pathname === path,
    [pathname],
  );

  return (
    <a href={route} style={{ textDecoration: "none", color: "#000000" }}>
      <li
        className={isLinkActive(route) ? "active" : ""}
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {imgSrc === "text-content" ? (
          <CreateContentTextIcon />
        ) : (
          <CreateContentMediaIcon />
        )}
        <span style={{ marginLeft: 5 }}>{label}</span>
      </li>
    </a>
  );
}

function CreateContentSidebar() {
  return (
    <>
      <div className="sidebar">
        <ul className="sidebar-ul">
          <SidebarLink
            label="Media Content"
            imgSrc="media-content"
            route="/create-post"
          />
          {/* <SidebarLink
            label="Text Content"
            imgSrc="text-content"
            route="/create-text"
          /> */}
        </ul>
      </div>

      <ShortsSdkVersion />
    </>
  );
}

SidebarLink.propTypes = {
  route: PropTypes.string,
  label: PropTypes.string,
  imgSrc: PropTypes.string,
};

export default CreateContentSidebar;
